import styled from 'styled-components';
import { getSpacingToken } from '@optimus-web/core';

export const NoItemsContainer = styled.div`
    margin-left: ${getSpacingToken('700')}px;
`;
